var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Layout"},[_c('el-scrollbar',[_c('Menu',{staticClass:"left",attrs:{"iscollapse":_vm.iscollapse}})],1),_vm._v(" "),_c('Content',{staticClass:"right",class:{ rightActive: _vm.iscollapse },attrs:{"iscollapse":_vm.iscollapse},on:{"changCollapse":_vm.changCollapse}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ccd77b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manage_views/main.vue
// module id = null
// module chunks = 